module.exports = __webpack_public_path__ + "media/images/colorpicker/alpha-1f3c0d627b6644c4b4eab8403e074a8e.png";